export const en: object = {
  configurator: {
    additionalRequiredSolution: '1 Additional Required Solution',
    additionalRequiredSolution_plural: '{{count}} Additional Required Solutions',
    startDate: 'Start Date',
    licenseMaterial: 'License Material',
    licenseDetails: 'License Details',
    backToSolutionPage: 'Back',
    backToSolutionPageMobile: 'Back',
    configureYourSolution: 'Configure',
    yourConfiguration: 'Your configuration',
    pricingSummary: 'Pricing Summary',
    recurringTotal: 'Recurring Total',
    totalCost: 'Total Cost',
    checkOut: 'Check out',
    orderSummary: 'Order Summary',
    partnerDiscount: 'Partner Discount',
    per: 'Per',
    month: 'Month',
    date: {
      endDate: 'End Date: ',
      startDate: 'Start Date: ',
      yearsAndMonths: '{{years}} years, {{months}} months',
      invalid: 'Enter a date in the format DD-MMM-YYYY',
      required: 'Start date is a required field',
      minDate: 'Date must be later than {{minDate}}',
      maxDate: 'Date must be earlier than {{maxDate}}',
      renewal: 'Renews automatically',
      renewalTooltip:
        'Your subscription automatically renews at the term selected. You can cancel your subscription for the next interval by notifying 30 days prior to the end of the current term.',
      recurringMonths: 'Every {{months}} Months',
      recurringYears: '{{months}} Months ({{years}} Years)',
      annual: 'Annual',
      year: '{{months}} Months (1 Year)',
    },
    deploymentSystems: {
      deployment: 'Deployment',
      system_plural: 'Systems',
      system: 'System',
      description: 'Additional licenses will automatically be deployed on all relevant systems in your contract:',
      columnSystemNumber: 'System Number',
      columnName: 'Name',
      columnRole: 'Role',
    },
    units: {
      usr: 'Users',
      blocksOf: 'Blocks of {{amount}} {{unit}}',
    },
    endDateToolTooltip: 'These licenses will be added to your existing contract and share that contract’s end date.',
    excludingTax: 'Excluding tax',
    pricingBillingTermsApply: 'Existing contract pricing, billing and terms apply',
    quantity: {
      required: 'Quantity is a required field',
      noNegatives: 'Quantity must be a positive number',
      onlyWholeNumbers: 'Quantity must be a whole number',
      minimum: 'Quantity must be at least {{value}}',
      maximum: 'Quantity must be at most {{value}}',
      outOfBounds: 'Please enter a quantity ({{minValue}}-{{maxValue}})',
      step: 'Quantity must be a multiple of {{value}}',
      minimumOf: 'Minimum of {{value}} {{unit}}',
      maximumOf: 'Maximum of {{value}} {{unit}}',
      incrementsOf: 'Increments of {{amount}} {{unit}}',
      minimumWithIncrements: 'Minimum of {{value}} {{unit}} in increments of {{amount}}',
    },
    spendamount: {
      required: 'Spend Amount is a required field',
      noNegatives: 'Spend Amount must be a positive number',
      onlyWholeNumbers: 'Spend Amount must be a whole number',
      minimum: 'Spend Amount must be at least {{value}}',
      maximum: 'Spend Amount must be at most {{value}}',
      outOfBounds: 'Please enter a Spend Amount ({{minValue}}-{{maxValue}})',
      minimumOf: 'Minimum of {{value}} {{unit}}',
      minimumWithIncrements: 'Minimum of {{value}} {{unit}} in increments of {{amount}}',
    },
    addToCart: {
      buttonUpdateCart: 'Update Cart',
      buttonContinueToCart: 'Continue',
    },
    addLicense: 'Add License',
    addLicenses: 'Add Licenses',
    editAdditionalLicenses: 'Edit Additional Licenses',
    editOrderDetails: 'Edit Order Details',
    closeModalLabel: 'Close modal and discard changed',
    partOfBundle: '{{productName}} ({{product}}) was initially purchased as part of a solution bundle.',
    orderUpsellBundle:
      ' To add licenses to your subscription, you must purchase additional licenses of one of the solutions below:',
    requestLicenses: 'Request Licenses',
    requestAdditionalLicenses: 'Request Additional Licenses',
    yourSolutions: 'Your Solutions',
    completeFormCta:
      'To purchase additional licenses of this solution, please complete the form below to contact the SAP Store support team.',
    selfServiceOrdering:
      'Self-service ordering for these licenses will be coming soon to help you add to your subscription quickly and easily.',
    subtotal: 'Subtotal',
    yearByYearPricingBreakdown: 'Year-by-Year Pricing Breakdown',
    additionalServicesFee: 'Additional Services Fee',
    orderTotal: 'Order Total',
    taxCalculationCheckout: 'Tax calculated at Checkout',
    taxDiscountsCalculationCheckout: 'Tax and discounts calculated at Checkout',
    psTaxExclusion: 'Excluding Tax',
    errorMessage: {
      btnText: 'View Cart',
    },
    error: {
      somethingWrong: 'Something went wrong',
      contactUsLink: 'contact us',
      code: '(Code: {{errorCode}})',
      tryAgain: {
        message1:
          'It seems there’s been an issue with our system. Please try again later. If the problem persists, don’t hesitate to ',
        buttonText: 'Try again',
      },
      contactUs: {
        message: 'It seems there’s been an issue with our system. Please ',
        proceed: ' to proceed.',
        buttonText: 'Contact us',
        supportRequest: 'create a support request',
      },
      newContract: {
        headline: 'Start a new contract?',
        message1: 'Your organization has an existing contract for',
        message2: 'If you would like to start a new contract, please contact your sales representative or',
        message3: 'contact us',
      },
      addToContract: {
        headline: 'Add to your existing contract?',
        message1: 'Your organization has an existing contract for',
        message2: '. Click below to buy more credits with the same contract terms.',
        message3: 'If you would like to start a new contract, please contact your sales representative or',
        buttonText: 'Get More',
      },
      addToCart: {
        multiCurrencyCart:
          'This item cannot be purchased together with the items in your cart as they are using different currencies. Please check out your cart first.',
      },
      addCompanyDetails: {
        headline: 'Add company details',
        message1: 'To purchase',
        message2:
          ', we need more information about your organization. ' + 'To add this information to your account, please ',
      },
      checkoutUnavailable: {
        headline: 'Sorry, checkout is blocked',
        message1:
          'The existing contract can not be completed through SAP Store online or this purchase requires special user authorization.',
        message2: 'Please contact your sales representative or contact SAP Store by ',
        buttonText: 'Return to Solution Page',
        buttonText2: 'creating a support request.',
      },
      restructure: {
        headline: 'Your contract is eligible for an upgrade',
        message1: 'We recommend upgrading your  ',
        message2: 'to ',
        message3: 'All existing data will be migrated. ',
        message4: 'If you would like to start a new contract, please contact your sales representative or ',
        buttonText: 'Back to Solution Page',
        buttonText2: 'Upgrade Now',
      },
      noError: '',
      general: {
        message: 'It seems there’s been an issue with our system. ',
        proceed: ' to proceed.',
        buttonText: 'Contact us',
      },
    },
    euAccessTooltip:
      'EU Access is an additional service element whereby SAP restricts remote data access and data storage to European Union (EU), European Economic Area (EEA), and Switzerland only.',
    on: 'On',
    off: 'Off',
    reset: 'Reset to Default configuration',
    bookmark: 'Bookmark',
    globalAccounts: {
      addToGlobalAccount: 'Global Account',
      addToGlobalAccountDescription: 'Add this solution to your existing SAP BTP Global Account',
      accountDetailsRows: 'Global Account ID, Commercial Model, Date Created',
      gaNotSelectedInfoNote:
        'If you uncheck this configuration, a new BTP global account will be created with this order.',
      gaInfoNoteCtaQuestion: 'Don’t know what’s BTP Global Account',
      gaInfoNoteContactHere: 'Contact your sales representative or learn more about BTP Global Account',
      gaInfoNoteContactHereLinkText: 'here',
      errors: {
        missingPurchaseRole1:
          'As this purchase will be modifying the configuration of an existing tenant/landscape, special authorization (Purchase Licenses) is required to place this order. This can be granted to you by one of',
        missingPurchaseRole2: 'your company’s administrators',
        missingPurchaseRole3: 'Please reach out to one of them to obtain that authorization.',
        required: 'Please select an account when this solution is added to existing BTP global account.',
      },
    },
    ctaValidateInfoMessage:
      'Please wait while we check if you have any pre-existing contracts which may affect this purchase.',
    orderRestructureUpgradeNotification: 'You are about to upgrade your existing {{0}} agreement to a {{1}} agreement.',
    orderRestructureUpgradeOpenModalLink: 'Learn how this purchase will effect your contract, billing, and payment',
    orderRestructureUpgradeModalHeading: 'How will this purchase effect my contract, billing, and payment?',
    orderRestructureUpgradeModalContent:
      '<ol type="1" class="px-4">' +
      '<li>  Contract<br><ol class="px-4" type="a">' +
      '<li> The existing agreement will be <strong>terminated</strong> at the end of the current month.</li>' +
      '<li> A <strong>new agreement</strong> will begin at the specified start date.</li>' +
      '</li></ol></li><br>' +
      '<li>  Billing / Payment <br><ol class="px-4" type="a">' +
      '<li> The existing agreement will be billed <strong>in arrears</strong> one more time, at the beginning of next month for the current month.</li>' +
      '<li> The new agreement will be billed <strong>in advance</strong>, at the beginning of the new contract.</li>' +
      '</li></ol></li><br>' +
      '<li>  Tenant / Global Account <br><ol class="px-4" type="a">' +
      '<li> The Global Account (GA) and all the <strong>content and configuration</strong> of the existing agreement will be carried over to the new agreement.</li>' +
      '<li> The <strong>existing administrator(s)</strong> of the GA will remain the same. If you specify a new IT contact during checkout, this person will be added to the list of GA admins. Any changes to existing admins must be done in the SAP BTP Cockpit.' +
      '</li></ol></li></ol>',
    header: {
      initialUpdateMessage: 'Loading',
    },
    addOns: {
      errors: {
        required: 'Please make a selection',
      },
    },
    leavePageModal: {
      headline: 'Unsaved Configuration',
      text: 'Your current configuration hasn’t been added to the cart and may be lost if you leave this page.',
      cancelButton: 'Cancel',
      continueButton: 'Continue',
    },
  },
};
